function cov_1g50hl2z3u() {
  var path = "/app/src/utils/get-device-type.ts";
  var hash = "9cfa02e80f47f4718bbffda14deebe6808f030b0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-device-type.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 29
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 12,
          column: 3
        }
      },
      "2": {
        start: {
          line: 7,
          column: 6
        },
        end: {
          line: 7,
          column: 28
        }
      },
      "3": {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 35
        }
      },
      "4": {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 11,
          column: 36
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 29
          },
          end: {
            line: 4,
            column: 30
          }
        },
        loc: {
          start: {
            line: 4,
            column: 35
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 4
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 6,
            column: 4
          },
          end: {
            line: 7,
            column: 28
          }
        }, {
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 9,
            column: 35
          }
        }, {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 11,
            column: 36
          }
        }],
        line: 5
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9cfa02e80f47f4718bbffda14deebe6808f030b0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1g50hl2z3u = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1g50hl2z3u();
import isMobile from 'ismobilejs/dist/isMobile.min';
import { getIsMobileWebview } from 'src/utils/get-is-mobile-webview';
cov_1g50hl2z3u().s[0]++;
export var getDeviceType = function getDeviceType() {
  cov_1g50hl2z3u().f[0]++;
  cov_1g50hl2z3u().s[1]++;
  switch (true) {
    case getIsMobileWebview():
      cov_1g50hl2z3u().b[0][0]++;
      cov_1g50hl2z3u().s[2]++;
      return 'merchant app';
    case isMobile.phone:
      cov_1g50hl2z3u().b[0][1]++;
      cov_1g50hl2z3u().s[3]++;
      return 'merchant web mobile';
    default:
      cov_1g50hl2z3u().b[0][2]++;
      cov_1g50hl2z3u().s[4]++;
      return 'merchant web desktop';
  }
};